import { render, staticRenderFns } from "./OsRegistrationForm.vue?vue&type=template&id=c2ee0b5a&scoped=true"
import script from "./OsRegistrationForm.vue?vue&type=script&lang=ts"
export * from "./OsRegistrationForm.vue?vue&type=script&lang=ts"
import style0 from "./OsRegistrationForm.vue?vue&type=style&index=0&id=c2ee0b5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ee0b5a",
  null
  
)

export default component.exports